import axios from 'axios';
import { Dispatch, createAction } from '@reduxjs/toolkit';

import analytics from '~/utils/Analytics';
import { GreetEventContext, GREET_REPLIED } from '../Analytics';
import type { Reply } from '~/types/models/reply';
import { StateFunction } from '~/types/redux/share';
import { DefaultUpdateOrCreateResponse } from '~/App/Api/rest';
import { isAxiosError } from '~/utils/Axios';

export const creatingComment = createAction<string>('CREATING_COMMENT');

export const createdComment = createAction<Reply>('CREATED_COMMENT');

export const commentFocusChanged = createAction<boolean>(
  'COMMENT_BOX_FOCUS_CHANGE'
);

export const errorCreatingComment = createAction<string>(
  'COMMENT_CREATE_ERROR'
);

export const commentTextChanged = createAction<string>('COMMENT_TEXT_CHANGED');

export function createComment(
  commentText: string,
  videoReply: boolean = false
) {
  return async (
    dispatch: Dispatch,
    getState: StateFunction
  ): Promise<Reply | undefined> => {
    if (commentText == null) {
      const state = getState();
      commentText = state.comments.value;
    }

    dispatch(creatingComment(commentText));

    const state = getState();

    const url = `${state.root.url!}/replies`;

    try {
      const res = await axios.post<DefaultUpdateOrCreateResponse<Reply>>(
        url,
        {
          content: commentText,
          profile_id: state.root.profile?.id,
          video_reply: videoReply ?? undefined,
          context: GreetEventContext.LandingPage,
        },
        {
          headers: {
            Accept: 'application/json',
          },
          withCredentials: true,
        }
      );

      if (!videoReply) {
        dispatch(createdComment(res.data.data));

        void analytics.track(GREET_REPLIED, {
          templateType: state.root.messageTemplate.template_type,
          context: GreetEventContext.LandingPage,
        });
      }

      return Promise.resolve(res.data.data);
    } catch (e) {
      if (isAxiosError<Record<string, string>>(e) && e.response) {
        const key = Object.keys(e.response.data)[0];
        const message = e.response.data[key];

        dispatch(errorCreatingComment(message));
      }

      return Promise.reject();
    }
  };
}

export const VIDEO_PLAY_ERROR = 'VIDEO_PLAY_ERROR';
export const videoPlayError = createAction<{
  value: string;
  code: string | number;
}>(VIDEO_PLAY_ERROR);

export const VIDEO_PLAY_VIEW = 'VIDEO_PLAY_VIEW';
export function videoPlayView() {
  return (_: Dispatch, getState: StateFunction) => {
    const greet = getState().root.model;

    interface StoreViewResponse {
      view: boolean;
    }

    return axios.post<StoreViewResponse>(`/g/${greet.slug}/views`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
      },
      credentials: 'same-origin',
    });
  };
}
